import React, { useEffect, useRef } from "react";
import './OurScience.css';
import Navbar from "../Navbar/Navbar";

// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AbsractMolecule from './ScienceImages/abstractmolecule.png';
import Moleculebig from './ScienceImages/moleculebig.png';
import Sciecnelabratory from './ScienceImages/sciencelabratory.png';

import Mdidrugs from './ScienceImages/mdidrugs.png';
import Personbulb from './ScienceImages/personbulb.png';
import Tubesearch from './ScienceImages/tubesearch.png';

import Sciencedna from './ScienceImages/sciencedna.png';
import Molecules from './ScienceImages/molecules.png';
import Moleculebig2 from './ScienceImages/moleculebig2.png';
import Footer from "../Footer/Footer";
import EastIcon from '@mui/icons-material/East';
import { useNavigate } from "react-router-dom";

import Manufacture1 from './ScienceImages/oursciencemanu1.png';
import Manufacture2 from './ScienceImages/oursciencemanu2.png';
import Manufacture3 from './ScienceImages/oursciencemanu3.png';


function OurScience(){
    const navigate = useNavigate();
    const renderOnlyOnce = useRef(false);
    useEffect(()=>{
        if(!renderOnlyOnce.current){
            window.scrollTo({top:0,behavior:'instant'});
            renderOnlyOnce.current=true;
        }
        
    },[]);
    return(
        <>
            <div className="ourscience-container">
                <Navbar/>
                <div className="ourscience-topdiv">
                    <div className="ourscience-topdiv-inner">
                        {/* topdiv content div */}
                        <div className="ourscience-topdiv-first">
                            <h1>Precision Science for a  
                            <span style={{fontStyle:'italic',color:'#4BC1FF',fontWeight:'500'}}> Healthier</span> Tomorrow</h1>
                            <h2>Discover our journey of innovation and commitment to advancing pharmaceuticals.</h2>
                            {/* <div className="ourscience-topdiv-explorebtn" >
                                <p>Explore Our Research</p>
                            </div> */}

                            {/* blurimages */}
                            <div className="ourscience-topdiv-first-blur1"></div>
                        </div>
                        <div className="ourScience-topdiv-second">
                            <div className="ourscience-topdiv-second-allimages">
                                <div className="ourscience-labratory-img">
                                    <img src={Sciecnelabratory} alt='sciencelabratory'/>
                                </div>

                                <div className="ourscience-labratory-img1">
                                    <img src={Moleculebig} alt='Molecule big'/>
                                </div>

                                <div className="ourscience-labratory-img2">
                                    <img src={AbsractMolecule} alt='abstarct molecule'/>
                                </div>

                                {/* blur images */}
                                <div className="ourscience-secondtopnav-blur1"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ourscience-seconddiv">
                    <div className="ourscience-seconddiv-inner">
                        <div className="ourscience-seconddiv-headerpara">
                            <h2>Research & Development</h2>
                            <p>At Arde’s Laboratories, we prioritize innovation through advanced research in pharmaceuticals, with a commitment to creating impactful medical solutions.</p>
                        </div>

                        <div className="ourvalues-grid-container" style={{marginTop:70}}>
                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <img src={Tubesearch} alt='tubeSearch'/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>Innovative R&D Culture</h2>
                                    <p>
                                        A diverse and creative environment that encourages scientific curiosity.
                                    </p>
                                </div>
                            </div>

                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <img src={Mdidrugs} alt='mdidrugs'/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>Advanced Drug Discovery</h2>
                                    <p>
                                    Specializing in small molecules, peptides, and oligonucleotides.
                                    </p>
                                </div>
                            </div>

                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <img src={Personbulb} alt='personbulb'/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>Strategic Collaborations</h2>
                                    <p>
                                        Partnering with academic and industry leaders to drive research forward.  
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* ourscvience blur images */}
                        <div className="ourscience-seconddiv-blur1"></div>
                        <div className="ourscience-seconddiv-blur2"></div>
                        <div className="ourscience-seconddiv-blur3"></div>
                    </div>
                </div>

                <div className="ourscience-thirddiv">
                    <div className="ourscience-thirddiv-inner">
                        <h2 className="ourscience-thirddiv-header">our focus areas</h2>

                        {/* small molecules */}
                        <div className="ourscience-thirddiv-eachdiv">
                            <div className="ourscience-thirddiv-eachdiv-one">
                                <h2>1. Small Molecules</h2>
                                <p>
                                    Developing therapies for oncology, cardiovascular, and rare diseases.Our small molecule research is 
                                    aimed at creating targeted treatments for specific conditions, improving patient outcomes, and addressing unmet medical needs in a 
                                    wide range of diseases.
                                </p>

                            </div>
                            <div className="ourscience-thirddiv-eachdiv-two">
                                <div className="ourscience-thirddiv-eachdiv-twoinner">
                                    <div className="ourscience-thirddiv-eachdiv-twoimg">
                                        <img src={Moleculebig2} alt='molecules'/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="ourscience-thirddiv-eachdiv">
                            <div className="ourscience-thirddiv-eachdiv-two">
                                <div className="ourscience-thirddiv-eachdiv-twoinner">
                                    <div className="ourscience-thirddiv-eachdiv-twoimg">
                                        <img src={Sciencedna} alt='molecules'/>
                                    </div>
                                </div>
                            </div>
                            <div className="ourscience-thirddiv-eachdiv-one">
                                <h2>2. Peptides</h2>
                                <p>
                                    Innovating in therapeutic peptide design and drug delivery systems.Our peptide research focuses on developing bioactive molecules that can interact with cells in a controlled manner, supporting targeted and safe drug delivery.
                                </p>
                            </div>
                        </div>

                        <div className="ourscience-thirddiv-eachdiv">
                            
                            <div className="ourscience-thirddiv-eachdiv-one">
                                <h2>3. Oligonucleotides</h2>
                                <p>
                                    Advancing gene therapy and RNA-based treatments.Our research in oligonucleotides aims to unlock the potential of gene therapy, allowing for treatments that directly target genetic material, with promising applications in genetic disorders and RNA-based therapies.
                                </p>
                            </div>
                            <div className="ourscience-thirddiv-eachdiv-two">
                                <div className="ourscience-thirddiv-eachdiv-twoinner">
                                    <div className="ourscience-thirddiv-eachdiv-twoimg">
                                        <img src={Molecules} alt='molecules'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* last to second div */}
                <div className="ourscience-middlefourth-div"></div>
                <div className="ourscience-fourthdiv">
                    <div className="ourscience-fourthdiv-inner">
                        <div className="ourscience-fourthdiv-first">
                            <h1 style={{color:'#0097D6'}}>Manufacturing</h1>
                            <h1>Excellence</h1>
                            <p>A commitment to quality, precision, and innovation in every step of the manufacturing process. Arde’s Laboratories follows rigorous standards and advanced practices to ensure the highest level of excellence in API production, technology transfer, and third-party collaborations.</p>
                            <div className="ourscience-fourthdiv-first-one" >
                                <div className="ourscience-fourthdiv-first-one1"  onClick={()=>navigate('/aboutus')}>
                                    <p style={{whiteSpace:'nowrap'}} >about us</p>
                                </div>
                                <div className="ourscience-fourthdiv-first-one2" style={{cursor:'pointer'}} onClick={()=>navigate('/career')}>
                                    <p style={{whiteSpace:'nowrap'}} >know more careers</p>
                                    <EastIcon sx={{fontSize:20}}/>
                                </div>
                            </div>
                        </div>
                        <div className="ourscience-fourthdiv-second">
                            <div className="ourscience-fourthdiv-second-images">
                                <div className="ourscience-fourthdiv-second-img2">
                                    <img src={Manufacture2} alt='manufacture2'/>
                                </div>
                                <div className="ourscience-fourthdiv-second-img1">
                                    <img src={Manufacture1} alt='manufacture1'/>
                                </div>
                                
                                <div className="ourscience-fourthdiv-second-img3">
                                    <img src={Manufacture3} alt='manufacture3'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* footer */}
                <Footer/>
            </div>
        </>
    );
}

export default OurScience;